const defaultOptions = {
    color: 'rgb(254 65 85 / var(--tw-bg-opacity))',
    failedColor: '#f44336',
    thickness: '2px',
};

export default defaultOptions;
